import {type InputHTMLAttributes, type ReactNode, forwardRef} from 'react'
import {InputTextField} from '../input-text-field/InputTextField'

export interface InputNumberFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'> {
  /** Applies error styling (red border + background) */
  isError?: boolean
  /** Icon rendered on the left side of the input */
  leftIcon?: ReactNode
  /** Icon rendered on the right side of the input */
  rightIcon?: ReactNode
}

export const InputNumberField = forwardRef<HTMLInputElement, InputNumberFieldProps>(
  (props, ref) => <InputTextField ref={ref} type="tel" {...props} />,
)

InputNumberField.displayName = 'InputNumberField'
